export const getActivationStatus = (activationStatus) => {
  if (!activationStatus) {
    return 0
  }

  return activationStatus === 'Yes' ? 1 : 0
}
